import { Autocomplete, TextField } from '@mui/material';
import React from 'react'
import useContentUpload from '../../../hooks/useContentUpload';

export const PaperAutoComplete = ({
    handlePaper,
    values,
    updatePaper,


}) => {


    const { examData, singleSubject, loading, error } = useContentUpload();

    // fucntion to remove all theory and practical paper since perfomance is for objective only
    const filteredUserCategory = examData?.filter(item =>
        !item?.examName?.includes("Theory") && !item?.examName?.includes("Practical")
    );



    return (
        <div>
            <Autocomplete
                sx={{ width: 200 }}
                id="combo-box-demo"
                size="small"

                options={filteredUserCategory}
                values={values || ""}
                onChange={(e, value) => {
                    if (value) {
                        handlePaper(e, value);
                        updatePaper(value)
                    }

                }}
                getOptionLabel={(option) => {
                    return `${option.examName}`;
                }}
                isOptionEqualToValue={(option, value) => {
                    return option.examId === value.examId;
                }} // Compare options based on ProfileId
                loading={loading}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Paper"
                        className="mb-1"
                        variant="outlined"
                    // InputProps={{
                    //     ...params.InputProps,
                    //     endAdornment: !disabled ? (
                    //         <React.Fragment>
                    //             {loading ? (
                    //                 <CircularProgress color="inherit" size={20} />
                    //             ) : null}
                    //             {params.InputProps.endAdornment}
                    //         </React.Fragment>
                    //     ) : (
                    //         ""
                    //     ),
                    // }}
                    />
                )}
            />
        </div>
    )
}
